<template>
  <span>
    <font-awesome-icon
      v-if="isVisible"
      icon="circle"
      size="xs"
      class="text-danger"
    />
  </span>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState("config", ["count_alerts"]),
    ...mapGetters("auth", ["existsRole"]),
    canLoad() {
      return this.existsRole?.("gestor-financeiro");
    },
    isVisible() {
      return !this.loading && this.count_alerts > 0 && this.canLoad;
    },
  },
  methods: {
    ...mapActions("config", ["ActionGetCount"]),
  },
  async created() {
    if (this.canLoad) {
      this.loading = true;
      await this.ActionGetCount();
      this.loading = false;
    }
  },
};
</script>
